import { useState } from 'react'

type useModalType = (
    isOpenInitial: boolean
) => [boolean, (newIsOpen: boolean) => void]

export const useModal: useModalType = (isOpenInitial = false) => {
    const [isOpen, setIsOpen] = useState(isOpenInitial)

    const setModal = (newIsOpen: boolean): void => {
        setIsOpen(newIsOpen)
        if (newIsOpen) {
            return document.body.classList.add('mobileMenuOpen')
        }
        document.body.classList.remove('mobileMenuOpen')
    }

    return [isOpen, setModal]
}
